import s from "./thirdStep.module.css";
import {useThirdStep} from "./useThirdStep";
import AnswerInput from "./AnswerInput";
import AdditionalComment from "./AdditionalComment";
import {firstStepBackground, thirdStepBackground} from "../../../../assets";
import {useAppContext} from "../../../../contexts";

const ThirdStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate,
        currentStep,
        showAlert
    } = props;

    // Component logic data
    const componentProps = useThirdStep({
        handleStepChange,
        handlePayloadUpdate
    });

    // Destructured component logic data
    const {
        formValues,
        shouldDisableOptions,
        handleChange,
        handleSubmit
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div className={`${s.root} ${(currentStep !== 3 || currentStep === 3 && showAlert) ? s.hideContent : ""}`}>
            <div className={`w-full flex flex-col md:flex-row items-start justify-between gap-y-12 gap-x-24`}>
                <div>
                    <h1 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                        Você encontrou tudo que precisava?
                    </h1>
                    <form
                        onSubmit={e => handleSubmit(e)}
                        className={`w-full flex flex-col items-start justify-between gap-y-12`}
                    >
                        <div className={"grid grid-cols-3 mt-6 w-full"}>
                            <AnswerInput
                                value={"1"}
                                label={"Sim"}
                                formValues={formValues}
                                handleChange={handleChange}
                                shouldDisableOptions={shouldDisableOptions}
                            />
                            <AnswerInput
                                value={"0"}
                                label={"Não"}
                                formValues={formValues}
                                handleChange={handleChange}
                                shouldDisableOptions={shouldDisableOptions}
                            />
                        </div>
                        <AdditionalComment
                            formValues={formValues}
                            handleChange={handleChange}
                        />
                    </form>
                </div>
                <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
                    <img
                        src={thirdStepBackground}
                        alt="Background image"
                    />
                </div>
            </div>
        </div>
    )
}

export default ThirdStep;
